/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PolicyIndexRouteImport } from './routes/policy/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminSitesRouteImport } from './routes/admin/sites'
import { Route as AdminCasesCaseIdRouteImport } from './routes/admin/cases.$caseId'

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyIndexRoute = PolicyIndexRouteImport.update({
  id: '/policy/',
  path: '/policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSitesRoute = AdminSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCasesCaseIdRoute = AdminCasesCaseIdRouteImport.update({
  id: '/cases/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/sites': typeof AdminSitesRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/policy': typeof PolicyIndexRoute
  '/admin/cases/$caseId': typeof AdminCasesCaseIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/sites': typeof AdminSitesRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/policy': typeof PolicyIndexRoute
  '/admin/cases/$caseId': typeof AdminCasesCaseIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/sites': typeof AdminSitesRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/policy/': typeof PolicyIndexRoute
  '/admin/cases/$caseId': typeof AdminCasesCaseIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin/sites'
    | '/admin/'
    | '/dashboard'
    | '/policy'
    | '/admin/cases/$caseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/sites'
    | '/admin'
    | '/dashboard'
    | '/policy'
    | '/admin/cases/$caseId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin/sites'
    | '/admin/'
    | '/dashboard/'
    | '/policy/'
    | '/admin/cases/$caseId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  PolicyIndexRoute: typeof PolicyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy/': {
      id: '/policy/'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sites': {
      id: '/admin/sites'
      path: '/sites'
      fullPath: '/admin/sites'
      preLoaderRoute: typeof AdminSitesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/cases/$caseId': {
      id: '/admin/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/admin/cases/$caseId'
      preLoaderRoute: typeof AdminCasesCaseIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminSitesRoute: typeof AdminSitesRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCasesCaseIdRoute: typeof AdminCasesCaseIdRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminSitesRoute: AdminSitesRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCasesCaseIdRoute: AdminCasesCaseIdRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  PolicyIndexRoute: PolicyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
